module.exports = __webpack_public_path__ + "img/57.2f36ff4f.jpg";